var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9.301 7.348L5.351.975c-.079-.013-.315.15-.328.228l3.94 6.363c.06.033.346-.148.338-.218z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M7.487 8.756l-3.94-6.364c-.079-.014-.45.171-.464.25l4.07 6.345c.06.032.342-.162.334-.231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M7.604 9.738L.485 7.67c-.068.043-.211.39-.17.457l7.187 2.093c.066-.016.155-.437.102-.483z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0E0E0C",
    d: "M7.158 13.776c2.665 1.186 5.916-.3 7.261-3.321 1.345-3.021.275-6.432-2.39-7.619-2.666-1.186-5.917.3-7.262 3.321-1.345 3.021-.275 6.432 2.39 7.619z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M6.388 13.444c2.666 1.187 5.917-.3 7.262-3.32 1.345-3.022.274-6.432-2.391-7.62-2.666-1.186-5.917.301-7.262 3.322-1.345 3.02-.274 6.431 2.391 7.618z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    d: "M6.63 12.903c2.4 1.07 5.33-.27 6.542-2.992 1.212-2.722.247-5.796-2.154-6.865-2.402-1.07-5.331.27-6.543 2.992-1.212 2.722-.248 5.796 2.154 6.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EBCEC",
    d: "M7.197 11.627c1.78.793 3.951-.2 4.85-2.217.898-2.018.183-4.296-1.597-5.088-1.78-.793-3.951.2-4.85 2.218-.898 2.017-.183 4.295 1.597 5.087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1910",
    d: "M7.933 9.975c.975.434 2.164-.11 2.656-1.215.491-1.104.1-2.352-.875-2.786-.975-.434-2.164.11-2.656 1.215-.491 1.104-.1 2.352.875 2.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC1C",
    d: "M8.354 9.028c.514.228 1.14-.058 1.399-.64.259-.581.053-1.238-.46-1.467-.514-.228-1.14.058-1.399.64-.259.581-.053 1.238.46 1.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1910",
    d: "M6.208 3.07c-.746-.283-1.913-.833-1.148-1.805L6.208 3.07zm-.843-1.964L6.45 2.877l.02-.283c.04-.757-.067-1.712-1.106-1.488z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00211A",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1910",
    d: "M4.226 5.15c-.921.036-2.413-.022-2.038-1.402L4.226 5.15zM2.484 3.37l1.974 1.52-.106-.328C4.049 3.694 3.5 2.666 2.484 3.37z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00211A",
    fillRule: "nonzero",
    transform: "rotate(-22 5.285 5.69)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD0A00",
    d: "M.388 8.102l2.493.693-.387.14c-.886.296-2.02.462-2.106-.833zm.166-.385l2.33.689-.204-.262c-.559-.689-1.399-1.435-2.126-.427z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#00211A",
    fillRule: "nonzero",
    xlinkHref: "#c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchery);
export default __webpack_public_path__ + "static/media/archery.012763a29b4ad1b29c24c8a1729bd851.svg";
export { ForwardRef as ReactComponent };